import JSZip from "jszip";
import { saveAs } from "file-saver";
import { IMAGE_END_POINT } from "../Api/EndPoints";
import API from "../Api/Api";
import { toast } from "react-toastify";

export const handleDownload = async (items, label) => {
  const zip = new JSZip();
  let fileCount = 0;

  for (const item of items) {
    console.log(`Processing item: ${item.id}`);

    const fileUrl =
      IMAGE_END_POINT + item?.attributes?.file?.data?.attributes?.url;
    let fileName =
      item?.attributes?.title ?? item?.attributes?.file?.data?.attributes?.name;

    if (!fileUrl || !fileName) {
      console.warn(`Skipping item ${item.id}: Invalid file URL or name`, {
        fileUrl,
        fileName,
      });
      continue;
    }

    fileName = `${item.id}_${fileName}`;

    try {
      console.log(`Fetching file: ${fileUrl}`);
      const response = await fetch(fileUrl);

      if (!response.ok) {
        console.warn(
          `Failed to fetch file for item ${item.id}: HTTP ${response.status}`,
        );
        continue;
      }

      const fileData = await response.blob();
      zip.file(fileName, fileData);
      fileCount++;
      console.log(`Added file to ZIP: ${fileName}`);
    } catch (error) {
      console.error(`Error processing item ${item.id}:`, error);
    }
  }

  if (fileCount === 0) {
    console.error("No files were added to the ZIP archive.");
    throw new Error("No valid files to download.");
  }

  console.log(`Generating ZIP with ${fileCount} files`);
  const zipBlob = await zip.generateAsync({ type: "blob" });
  saveAs(zipBlob, `${label}.zip`);
};

export const DownloadAddress = async (id, number, t) => {
  try {
    const response = await API.post(
      "api/delivery/download-address",
      {
        data: { deliveryId: id },
      },
      {
        responseType: "blob",
      },
    );

    const blob = new Blob([response.data], { type: "application/pdf" });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `adresse_livraison_${number}.pdf`;
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    toast.error(t ? t("Error downloading PDF") : "Error downloading PDF");
  }
};
export const DownloadPackingList = async (id, number, t) => {
  try {
    const response = await API.post(
      "api/delivery/download-packing-list",
      {
        data: { deliveryId: id },
      },
      {
        responseType: "blob",
      },
    );

    const blob = new Blob([response.data], { type: "application/pdf" });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `packing_list_${number}.pdf`;
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    toast.error(t ? t("Error downloading PDF") : "Error downloading PDF");
  }
};
